import React from 'react';
import styled from '@emotion/styled';
import { FixedGridItem, Row } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { CreditCardType } from '../../../../domain/models';
import { CreditCardFormSection } from '../CreditCardFormSection';
import { CreditCardTypeOption } from '../fields/CreditCardTypeOption';

const StyledSelectType = styled(CreditCardFormSection)`
	margin-bottom: 40px;
`;

export const SelectType = () => {
	const { t } = useTranslation();

	return (
		<StyledSelectType title={t('payment_form_select_card_type')}>
			<OptionsRow columns={2}>
				<CreditCardTypeOption type={CreditCardType.Mastercard} />
				<CreditCardTypeOption type={CreditCardType.Visa} />
				<CreditCardTypeOption type={CreditCardType.AmericanExpress} />
				<CreditCardTypeOption type={CreditCardType.Discover} />
			</OptionsRow>
		</StyledSelectType>
	);
};

const OptionsRow = styled(Row)`
	${FixedGridItem} {
		@media (min-width: 1280px) {
			width: auto;
		}
	}
`;
